/**
 * Credit-state → styling tokens for the AI-credits widget (`AiCredits.vue`).
 *
 * Single source of truth so the bar trigger, inline trigger, panel bar and the
 * warning banner never drift apart. Pure: takes the derived credit state and
 * returns Tailwind class strings + `AppProgressBar` / `AppAlert` variant names.
 *
 * @param {{ isRed?: boolean, isYellow?: boolean }} state
 * @returns {{ pill: string, text: string, triggerBar: string, triggerTrack: string, panelBar: string, alert: string }}
 */
export const getAiCreditTone = ({ isRed = false, isYellow = false } = {}) => {
  if (isRed) {
    return {
      pill:         'bg-red-100 border-red-200 text-red-600',
      text:         'text-red-600',
      triggerBar:   'red',    // AppProgressBar variant on the pill
      triggerTrack: 'bg-white/60',
      panelBar:     'red',    // AppProgressBar variant in the panel
      alert:        'error',  // AppAlert variant for the banner
    }
  }

  if (isYellow) {
    return {
      pill:         'bg-yellow-100 border-yellow-200 text-yellow-500',
      text:         'text-yellow-500',
      triggerBar:   'yellow',
      triggerTrack: 'bg-white/60',
      panelBar:     'yellow',
      alert:        'warning',
    }
  }

  // Default (healthy) state — matches Figma 25707:572571 + the shared header
  // pill: translucent dark fill (rgba(0,0,0,0.1)), blue-600 border, white text +
  // progress fill, solid blue-800 track. Keep `pill` in sync with AppButton
  // `variant="header"` so the AI-credits trigger matches its Add Cards / Switch
  // neighbours. The in-panel bar stays tint-1 on white.
  return {
    pill:         'bg-gray-800/10 hover:bg-gray-800/20 border-blue-600 text-white',
    text:         'text-white',
    triggerBar:   'white',
    triggerTrack: 'bg-blue-800',
    panelBar:     'tint',
    alert:        'warning',
  }
}
